/**
 * The rule alone, with no storage behind it (so `lib/api.ts` can use it without pulling IndexedDB in): a rave's
 * offline copy lives until two days after it ends — past raves work online only (the user, 2026-11-02;
 * `pastRaves.ts`).
 */
export const KEEP_AFTER_END_MS = 2 * 24 * 60 * 60_000;

/** Is a rave that ends at `endsAt` past its offline days? A rave with no end date is never past. */
export function overForOffline(endsAt: string | null | undefined, now = Date.now()): boolean {
  const end = endsAt ? Date.parse(endsAt) : NaN;
  return Number.isFinite(end) && end + KEEP_AFTER_END_MS <= now;
}
